import './shippers-alerts.service';
import './shippers-api.factory';
import './shippers-dialog-service.service';
import './shippers-requests.service';
import './shippers-service.service';
